import React from 'react'
import PrepListPage from './prep/PrepListPage'
import PrepDashboardPage from './prep/PrepDashboardPage'
import useUserSettingsStore from '../store/userSettings'
import usePrepRecoveryStore from '../store/prepRecoveryStore'

const Prep: React.FC = () => {
  const layout = useUserSettingsStore((state) => state.prep.layout)
  const recoveryOpen = usePrepRecoveryStore((state) => state.open)

  return layout === 'dashboard' && !recoveryOpen ? <PrepDashboardPage /> : <PrepListPage />
}

export default Prep
